import { Button, Heading, Paragraph, Stack } from '@customerio/pluma-components/react';
import { LottieAnimation } from './lottie-animation';
import * as styles from '../index.css';

const EVENT_CTA_URL =
  'https://customer.io/learn/announcements/moments-that-matter?utm_medium=referral&utm_source=customer.io&utm_campaign=q32026_july_feature_drop&utm_content=fly_login_page_post_webinar&utm_term=pmm';

// Lazy-loaded so the animation stays out of the initial login bundle.
const loadReachAnimation = () => import('@/assets/animations/referral/reach-animation.json');

/**
 * Marketing splash shown beside the login form on desktop. Ported from the
 * Ember `ReferralSplash`: Lottie animation, headline, copy, and CTA. Post-webinar
 * copy/links point to the July feature-drop recap (moments that matter).
 */
export function ReferralSplash() {
  return (
    <Stack className={styles.referralPanel} gap="200" alignInline="center" data-test-referral-splash-desktop>
      <LottieAnimation load={loadReachAnimation} className={styles.referralAnimation} />
      <Heading level="2" weight="semibold" className={styles.referralHeadline}>
        Show up when it matters
      </Heading>
      <Paragraph size="lg" color="invert" className={styles.referralSubtext}>
        Your customers are moving through the world in real time. Meet them when it counts. See over 10 new features
        live, now.
      </Paragraph>
      <Button
        href={EVENT_CTA_URL}
        isExternal={true}
        variant="primary"
        mt="200"
        className={styles.referralCtaButton}
        data-test-referral-cta
      >
        Explore what's new
      </Button>
    </Stack>
  );
}
